<template>
  <div class="topbar-container bg-light" :class="{'no-padd': !fixo}">
    <div class="py-4 py-md-3 bg-white shadow-sm" :class="{'fixed-top': fixo}">
      <div class="container text-center position-relative">
        <a href="javascript:" @click="voltar" class="btn position-absolute" style="left: 12px; top: -7px" aria-label="Voltar">
          <i class="fa fa-chevron-left text-dark"></i>
          <span class="d-none d-md-inline-block font-weight-bold ml-2">Voltar</span>
        </a>
        <div class="font-weight-bold m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; height: 24px">
          {{title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from './Icon'
  export default {
    name: "TopBar",
    components: {Icon},
    props: {
      title: String,
      link: [String, Boolean],
      event: [String, Boolean],
      fixo: {type: Boolean, default: true}
    },
    data() {
      return {
        sacola: true,
        token: localStorage.getItem('token'),
      }
    },

    methods: {
      voltar() {
        if (this.event) {
          this.$emit('voltar');

        } else if (this.link) {
          const url = this.$helpers.getUrlApp(this.$route.params?.id || '');
          const target = url || '/';

          if (this.$route.fullPath !== target) {
            this.$router.push(target);
          }

        } else {
          this.$router.go(-1);
        }
      }
    }
  }
</script>

<style scoped>
  .topbar-container {
    padding-bottom: 88px;
  }

  .topbar-container.no-padd {
    padding-bottom: 0!important;
  }

  .topbar-container .btn {
    align-items: center;
    border: 1px solid #e9ecef;
    border-radius: 50%;
    display: flex;
    height: 42px;
    justify-content: center;
    padding: 0;
    width: 42px;
  }

  @media (min-width: 768px) {
    .topbar-container {
      padding-bottom: 75px
    }

    .topbar-container .btn {
      border: none;
      border-radius: 12px!important;
      height: 38px;
      padding: 6px 12px;
      width: auto;
    }
  }
</style>
